module.exports = __webpack_public_path__ + "img/common_medicine.a38470ea.svg";